import { useEffect } from 'react';
import { createDomTranslationSession } from './domTranslationSession';

export function useDomAutoTranslate(language) {
  useEffect(() => {
    if (language === 'es') return undefined;
    const session = createDomTranslationSession(document.body, language);
    let timer;
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(session.scan, 80);
    };
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['placeholder','title','aria-label'] });
    schedule();
    return () => { observer.disconnect(); clearTimeout(timer); session.restore(); };
  }, [language]);
}
